module.exports = __webpack_public_path__ + "static/media/robot-green-happy-head.2c55a69f.svg";